import { useSearchParams } from "react-router-dom";
import { AuthConfig } from "@/features/admin/auth-config";

const TABS = ["login", "mfa", "session"] as const;
type Tab = (typeof TABS)[number];

export default function AdminAuthConfigPage(){
  const [searchParams] = useSearchParams();
  const sp = Object.fromEntries(searchParams.entries());
  const initialTab: Tab = TABS.includes(sp.tab as Tab) ? (sp.tab as Tab) : "login";
  return <AuthConfig initialTab={initialTab} />;
}
